import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listContactMessages() {
  const { data } = await axiosClient.get("/api/admin/contact-messages");
  return unwrapApiResponse({ data });
}

export async function getContactMessage(id) {
  const { data } = await axiosClient.get(`/api/admin/contact-messages/${id}`);
  return unwrapApiResponse({ data });
}

export async function markContactMessageRead(id, isRead) {
  const { data } = await axiosClient.patch(
    `/api/admin/contact-messages/${id}/read`,
    { isRead }
  );
  return unwrapApiResponse({ data });
}

export async function deleteContactMessage(id) {
  const { data } = await axiosClient.delete(`/api/admin/contact-messages/${id}`);
  return unwrapApiResponse({ data });
}
